import { lazy } from 'react';
function lazyWithPreload(factory) {
  const Component = /*#__PURE__*/lazy(factory);
  Component.preload = factory;
  return Component;
}
export const brandedStyleGenerationRegistryEntry = {
  namespace: 'BRANDED_STYLE_GENERATION',
  components: {
    FONT_PREVIEW: lazyWithPreload(() => import( /* webpackChunkName: "branded-style-generation-components" */'global-styles-ai-lib/components/theme-generation/FontPreviewCitation').then(m => ({
      default: m.FontPreviewCitation
    }))),
    COLOR_SWATCH_PREVIEW: lazyWithPreload(() => import( /* webpackChunkName: "branded-style-generation-components" */'global-styles-ai-lib/components/theme-generation/ColorPaletteCitation').then(m => ({
      default: m.ColorPaletteCitation
    })))
  }
};